import { get, post } from '../../services/api.service';
import { getStore } from '../../store';

export const getMonumentDataAPI = async (productId, width, depth) => {
    const {monument = null} = getStore().getState().configurator?.current?.configuration || {};
    const {headstone} = monument;
    // Simulate async API call
    return get(`/api/product-details/${productId}?headstone=${headstone?.reference}&width=${width}&depth=${depth}`)
        .then(response => {
            if (response.error) throw new Error("404");
            return response;
        })
        .catch(error => {
            console.error("Error fetching monument data:", error);
            throw error; // rethrow the error for further handling
        });
};

export const getProductInfoAPI = async (productId) => {
    // Simulate async API call
    const {monument = null} = getStore().getState().configurator?.current?.configuration || {};
    const {headstone} = monument;
    return get(`/api/product-info/${productId}?headstone=${headstone?.reference}`)
        .then(response => {
            if (response.error) throw new Error("404");
            return response;
        })
        .catch(error => {
            console.error("Error fetching product info:", error);
            throw error;
        });
};

export const getMonumentData = async (configRef) => {
    return get(`/api/configuration-details/${configRef}`)
        .then(response => {
            if (response.error) throw new Error("404");
            return response;
        })
        .catch(error => {
            console.error("Error fetching monument data:", error);
            throw error; // rethrow the error for further handling
        });
};

export const validateMonumentData = async (data) => {
    try {
        // Add validation logic here if needed
        if (!data) {
            throw new Error("Monument data is required");
        }
        
        // Save the monument data (combining both functions)
        const response = await post('/api/configuration-details', data);
        if (response.err) {
            throw new Error("Error validating/saving monument data");
        }
        else {
            return response;
        }
        
    } catch (error) {
        console.error("Error validating/saving monument data:", error);
        throw error; // rethrow the error for further handling
    }
}

export const getPriceData = async (data) => {
    // Simulate async API call
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve([]);
        }, 1000);
    });
}

// export const sanitizeMonumentData = (data) => {
//     const fieldsToSanitize = ['userValue', 'defaultValue', 'min', 'max', 'impact'];

//     if (data.groups && Array.isArray(data.groups)) {
//         data.groups.forEach(group => {
//             if (group.parts && Array.isArray(group.parts)) {
//                 group.parts.forEach(part => {
//                     if (part.dimensions && typeof part.dimensions === 'object') {
//                         Object.keys(part.dimensions).forEach(dimensionKey => {
//                             const dimension = part.dimensions[dimensionKey];
//                             if (dimension && typeof dimension === 'object') {
//                                 if (dimension.userValue === null) {
//                                     dimension.userValue = dimension.defaultValue || 0;
//                                 }
//                                 fieldsToSanitize.forEach(field => {
//                                     if (dimension.hasOwnProperty(field)) {
//                                         const value = dimension[field];
//                                         // Check if value is empty string, null, undefined, or not a number
//                                         if (value === "" || value === null || value === undefined || isNaN(Number(value))) {
//                                             dimension[field] = 0;
//                                         }
//                                     }
//                                 });
//                             }
//                         });
//                     }
//                 });
//             }
//         });
//     }

//     return data;
// };

export const sanitizeLayoutDataResp = (data) => {
    const {width, depth} = data?.layout?.dimensions;
    
    if (width && width.userValue === null) {
        width.userValue = width.defaultValue || 0;
    }
    if (depth && depth.userValue === null) {
        depth.userValue = depth.defaultValue || 0;
    }

    return data;
}

export const sanitizePositionsAndGroupId = (data) => {
    if (!data.groups) return data;
  
    data.groups.forEach(group => {
        group.parts.forEach(part => {
            if (part.position === null) {
            //Replace null with empty string
            part.position = "";
            }
        });
    });
  
    return data;
  };